<template>
  <main class="pt-24">
    <section id="home">
    <FunçaoPage1 />
    <PlanPage />
    </section>

    <section id="funcionalidades">
    <SobrePage2 />
    </section>

    <section id="sobrenos">
    <InicioPage4 />
    </section>

    <section id="informacoes">
    <CtaDiagnostico />
    </section>

    <section id="experimente">
    <FaqPage />
    </section>
  </main>
</template>

<script>
import FunçaoPage1 from "@/components/Funcionalidade/FunçaoPage1.vue";
import PlanPage from "@/components/Planos/PlanPage.vue";
import SobrePage2 from "@/components/Sobre/SobrePage2.vue";
import InicioPage4 from "@/components/Inicio/InicioPage4.vue";
import CtaDiagnostico from "@/components/Funcionalidade/CtaDiagnostico.vue";
import FaqPage from "@/components/FAQ/FaqPage.vue";

export default {
  name: "HomePage",
  components: {
    FunçaoPage1,
    PlanPage,
    SobrePage2,
    InicioPage4,
    CtaDiagnostico,
    FaqPage,
  },
};
</script>